// extracted by mini-css-extract-plugin
export default {"image":"eZ-z","loaded":"fZ-z"};